import { FC, memo } from 'react';

import { AppProviders } from '../../components';
import { TenantedApplicationConfigProviderProps } from './types/TenantedApplicationConfigProviderProps';
import { TenantedApplicationConfigContext } from './TenantedApplicationConfigContext';

const TenantedApplicationConfigProviderComponent: FC<
  TenantedApplicationConfigProviderProps
> = ({ children, tenantApplicationConfig }) => (
  <TenantedApplicationConfigContext.Provider value={tenantApplicationConfig}>
    <AppProviders>{children}</AppProviders>
  </TenantedApplicationConfigContext.Provider>
);

export const TenantedApplicationConfigProvider = memo(
  TenantedApplicationConfigProviderComponent,
);
